/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Land } from '../models';
// @ts-ignore
import { MautberechnungParam } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * MautService - axios parameter creator
 * @export
 */
export const MautServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Ländern für die Mautberechnung
         * @summary LaenderSuche
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLaender: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/maut/laender`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert die Mautberechnung
         * @summary Mautberechnung
         * @param {MautberechnungParam} [mautberechnungParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaut: async (mautberechnungParam?: MautberechnungParam, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/maut/mautberechnung`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mautberechnungParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MautService - functional programming interface
 * @export
 */
export const MautServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MautServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Ländern für die Mautberechnung
         * @summary LaenderSuche
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLaender(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Land>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLaender(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert die Mautberechnung
         * @summary Mautberechnung
         * @param {MautberechnungParam} [mautberechnungParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaut(mautberechnungParam?: MautberechnungParam, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MautberechnungParam>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaut(mautberechnungParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MautService - factory interface
 * @export
 */
export const MautServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MautServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Ländern für die Mautberechnung
         * @summary LaenderSuche
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLaender(options?: any): AxiosPromise<Array<Land>> {
            return localVarFp.getAllLaender(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert die Mautberechnung
         * @summary Mautberechnung
         * @param {MautberechnungParam} [mautberechnungParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaut(mautberechnungParam?: MautberechnungParam, options?: any): AxiosPromise<MautberechnungParam> {
            return localVarFp.getMaut(mautberechnungParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MautService - interface
 * @export
 * @interface MautService
 */
export interface MautServiceInterface {
    /**
     * Liefert eine Liste von Ländern für die Mautberechnung
     * @summary LaenderSuche
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MautServiceInterface
     */
    getAllLaender(options?: any): AxiosPromise<Array<Land>>;

    /**
     * Liefert die Mautberechnung
     * @summary Mautberechnung
     * @param {MautberechnungParam} [mautberechnungParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MautServiceInterface
     */
    getMaut(mautberechnungParam?: MautberechnungParam, options?: any): AxiosPromise<MautberechnungParam>;

}

/**
 * MautService - object-oriented interface
 * @export
 * @class MautService
 * @extends {BaseAPI}
 */
export class MautService extends BaseAPI implements MautServiceInterface {
    /**
     * Liefert eine Liste von Ländern für die Mautberechnung
     * @summary LaenderSuche
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MautService
     */
    public getAllLaender(options?: any) {
        return MautServiceFp(this.configuration).getAllLaender(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert die Mautberechnung
     * @summary Mautberechnung
     * @param {MautberechnungParam} [mautberechnungParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MautService
     */
    public getMaut(mautberechnungParam?: MautberechnungParam, options?: any) {
        return MautServiceFp(this.configuration).getMaut(mautberechnungParam, options).then((request) => request(this.axios, this.basePath));
    }
}
